import { decode } from '@helloextend/jwt'
import type { AccessToken } from '@helloextend/extend-api-client'

export function getTokenSub(accessToken: AccessToken): string {
  const { sub } = decode(accessToken) as { sub: string }
  return sub
}
